import { render, staticRenderFns } from "./InvoiceItemsList.vue?vue&type=template&id=86be4fe0"
import script from "./InvoiceItemsList.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports